export interface ArticleContent {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  date: string;
  readTime: string;
  image: string;
  slug: string;
  author: string;
  sections: ArticleSection[];
  tags: string[];
}

export interface ArticleSection {
  type: 'heading' | 'paragraph' | 'list' | 'tip';
  level?: 2 | 3;
  content?: string;
  items?: string[];
}

export const allArticles: ArticleContent[] = [
  {
    id: 'article-1',
    title: '2026年最值得入手的10款女士内裤推荐',
    excerpt: '经过30天实测对比，从舒适度、透气性、耐穿性三个维度，为你精选出今年最值得购买的女士内裤，涵盖多个价位和风格。',
    category: '品牌推荐',
    categorySlug: 'pinpai',
    date: '2026-08-05',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Beautifully%20arranged%20soft%20fabric%20textiles%20in%20blush%20pink%20and%20cream%20tones%20on%20a%20clean%20white%20surface%2C%20elegant%20minimalist%20flat%20lay%2C%20warm%20natural%20light%2C%20editorial%20lifestyle%20photography&width=1200&height=600&seq=article-detail-1&orientation=landscape',
    slug: '2026-top-10-recommendations',
    author: '小美',
    tags: ['品牌推荐', '实测对比', '2026推荐'],
    sections: [
      { type: 'heading', level: 2, content: '前言' },
      { type: 'paragraph', content: '一条合适的内裤是女性舒适感的基石。为了帮你选到真正好穿的内裤，我们团队花了30天时间，从线上购买了30个品牌的女士内裤，从舒适度、透气性、耐穿性、性价比四个维度进行了全面实测。以下是我们精挑细选出的10款最值得入手的女士内裤。' },
      { type: 'heading', level: 2, content: '评测标准说明' },
      { type: 'paragraph', content: '我们的评测采用百分制，其中舒适度占40%，透气性占25%，耐穿性占20%，性价比占15%。每款内裤均由3位不同体型的测试员穿着3天以上进行评估。' },
      { type: 'heading', level: 2, content: 'TOP 1-3：综合表现最佳' },
      { type: 'heading', level: 3, content: '第1名：优衣库 AIRism 无缝内裤' },
      { type: 'paragraph', content: '综合评分：92分。优衣库的AIRism系列一直是性价比之王。这款内裤采用独特的AIRism面料，触感丝滑凉爽，透气性在本次评测中排名第一。无缝设计完全无痕，贴合度极佳。价格仅59元，性价比无可匹敌。' },
      { type: 'heading', level: 3, content: '第2名：蕉内 301P 莫代尔内裤' },
      { type: 'paragraph', content: '综合评分：89分。蕉内是近年来崛起的国货内衣品牌，这款莫代尔内裤手感极其柔软，穿着几乎感觉不到存在。莫代尔面料吸湿性比纯棉高出50%，非常适合日常穿着。' },
      { type: 'heading', level: 3, content: '第3名：Victoria\'s Secret 纯棉内裤' },
      { type: 'paragraph', content: '综合评分：87分。维密的纯棉系列是经典中的经典。采用长绒棉材质，柔软亲肤，版型设计非常贴合亚洲女性身材。价格稍高但耐穿性出色，洗20次后基本无变形。' },
      { type: 'heading', level: 2, content: '购买建议' },
      { type: 'list', items: ['日常通勤首选优衣库AIRism和蕉内莫代尔系列', '追求性价比可以考虑国货品牌如蕉内、内外', '特殊场合推荐维密和Agent Provocateur', '运动时一定要选择专业运动内裤品牌', '敏感肌肤优先选择A类婴幼儿级纯棉内裤'] },
      { type: 'tip', content: '小贴士：新买的内裤一定要先洗再穿！生产过程中可能残留化学物质，清洗可以去除大部分有害残留。' },
    ],
  },
  {
    id: 'article-2',
    title: '内裤材质终极对比：棉质 vs 莫代尔 vs 真丝',
    excerpt: '不同材质的内裤在透气性、吸湿性、亲肤感上差异巨大。我们做了详细对比测试，帮你找到最适合自己肤质的内裤材质。',
    category: '材质对比',
    categorySlug: 'cailiao',
    date: '2026-08-03',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Three%20different%20fabric%20textures%20cotton%20modal%20and%20silk%20elegantly%20displayed%20side%20by%20side%20on%20a%20neutral%20warm%20background%2C%20macro%20texture%20details%20visible&width=1200&height=600&seq=article-detail-2&orientation=landscape',
    slug: 'fabric-comparison-guide',
    author: '小美',
    tags: ['材质对比', '纯棉', '莫代尔', '真丝'],
    sections: [
      { type: 'heading', level: 2, content: '为什么内裤材质如此重要？' },
      { type: 'paragraph', content: '内裤是直接接触私密部位的衣物，材质的选择直接影响穿着舒适度、私处健康和整体体验。选择不当可能导致过敏、闷热、摩擦不适等问题。那么，市面上主流的内裤材质各有什么特点？我们来逐一分析。' },
      { type: 'heading', level: 2, content: '纯棉内裤——经典之选' },
      { type: 'paragraph', content: '纯棉是最传统也最普及的内裤材质。优质纯棉内裤采用长绒棉制成，纤维长而细，手感柔软。透气性在所有材质中属于中上水平，亲肤性好，对皮肤的刺激性最低，是敏感肌肤的首选。' },
      { type: 'list', items: ['优点：透气性中等偏上、亲肤性好、不易过敏、价格实惠', '缺点：吸汗后不易干、弹性一般、多次洗涤后可能变硬', '推荐指数：★★★★★（日常穿着首选）'] },
      { type: 'heading', level: 2, content: '莫代尔内裤——丝滑新宠' },
      { type: 'paragraph', content: '莫代尔是由天然木浆制成的再生纤维素纤维，手感比纯棉更加丝滑柔软。它的吸湿性比纯棉高出约50%，透气性也更胜一筹。近年来备受欢迎，尤其适合夏季穿着。' },
      { type: 'list', items: ['优点：极柔软丝滑、吸湿性强、透气性好、不易起球', '缺点：价格比纯棉稍高、部分廉价莫代尔可能含有化纤混纺', '推荐指数：★★★★★（夏季首选）'] },
      { type: 'heading', level: 2, content: '真丝内裤——奢华享受' },
      { type: 'paragraph', content: '真丝内裤是最高端的选择，采用天然蚕丝制成，含有18种氨基酸，对皮肤有养护作用。触感如丝般顺滑，是所有材质中最亲肤的。但价格较高，需要精心保养。' },
      { type: 'list', items: ['优点：极致亲肤、含氨基酸养肤、温控性好（冬暖夏凉）', '缺点：价格高、不耐拉扯、需要手洗、不耐碱', '推荐指数：★★★★（预算充足时的极佳选择）'] },
      { type: 'heading', level: 2, content: '最终推荐' },
      { type: 'paragraph', content: '日常穿着我们推荐以纯棉为主，夏季可以搭配莫代尔材质。真丝内裤适合特殊场合或皮肤特别敏感时使用。无论选择哪种材质，请务必选择正规品牌，确保面料安全无害。' },
    ],
  },
  {
    id: 'article-3',
    title: '女士内裤尺码怎么选？完整测量指南',
    excerpt: '80%的女性穿着不适合自己尺码的内裤！学会正确的臀围、腰围测量方法，找到最适合自己的内裤尺码。',
    category: '尺码指南',
    categorySlug: 'chima',
    date: '2026-08-01',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20measuring%20tape%20and%20soft%20fabric%20on%20a%20warm%20cream%20surface%20with%20gentle%20shadows%2C%20minimalist%20flat%20lay%20composition%2C%20soft%20natural%20lighting&width=1200&height=600&seq=article-detail-3&orientation=landscape',
    slug: 'size-measurement-guide',
    author: '小美',
    tags: ['尺码指南', '测量方法', '选购技巧'],
    sections: [
      { type: 'heading', level: 2, content: '为什么尺码选择如此重要？' },
      { type: 'paragraph', content: '据统计，约80%的女性日常穿着不适合自己尺码的内裤。过紧的内裤会压迫腹部、影响血液循环、导致私处摩擦不适；过松则无法提供良好的包裹性。选对尺码是舒适穿着的第一步。' },
      { type: 'heading', level: 2, content: '正确测量方法' },
      { type: 'heading', level: 3, content: '臀围测量' },
      { type: 'paragraph', content: '臀围是选择内裤尺码最重要的数据。测量时，站立放松，用软尺绕臀部最丰满处一周。注意软尺要保持水平，不松不紧。建议在早上测量，因为一天中下午和晚上身体会有轻微水肿。' },
      { type: 'heading', level: 3, content: '腰围测量' },
      { type: 'paragraph', content: '腰围作为辅助参考数据。测量肚脐上方约2-3厘米处（自然腰线）的围度。自然呼吸，不要收腹。' },
      { type: 'heading', level: 2, content: '通用尺码对照表' },
      { type: 'list', items: [
        'S码：臀围80-86cm / 腰围60-66cm',
        'M码：臀围86-92cm / 腰围66-72cm',
        'L码：臀围92-98cm / 腰围72-78cm',
        'XL码：臀围98-104cm / 腰围78-84cm',
        'XXL码：臀围104-112cm / 腰围84-92cm',
      ]},
      { type: 'tip', content: '重要提示：不同品牌的尺码标准存在差异，购买前务必查看该品牌的尺码表。如果测量结果介于两个尺码之间，建议选择较大的那个尺码，舒适度优先。' },
      { type: 'heading', level: 2, content: '选购技巧' },
      { type: 'list', items: [
        '新品牌首次购买时，建议先买一条试穿',
        '孕期和产后尺码会变化，需要重新测量',
        '体重波动超过3公斤时，重新评估尺码',
        '弹力面料的内裤可以适当选择稍小半码',
      ]},
    ],
  },
];

export function getArticleBySlug(slug: string): ArticleContent | undefined {
  return allArticles.find((a) => a.slug === slug);
}

export function getRelatedArticles(currentSlug: string, categorySlug: string, limit: number = 3): ArticleContent[] {
  return allArticles
    .filter((a) => a.slug !== currentSlug && a.categorySlug === categorySlug)
    .slice(0, limit);
}